import { render, staticRenderFns } from "./StockMovementListItem.vue?vue&type=template&id=55cb9284&"
import script from "./StockMovementListItem.vue?vue&type=script&lang=js&"
export * from "./StockMovementListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "StockMovementListItem.vue"
export default component.exports